import {TFilter, TList} from '@/types';
import {TDetailsParams, TListItem} from './types';
import {post, get} from '../../http';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {getTransactionDetails, getTransactionList} from './mock';

// Get list of the transactions
export function apiV2TransactionsList(params: TFilter<TListItem>): Promise<TList<TListItem>> {
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;
  const url = '/f2c/v1/console/transactions';

  if (process.env.MOCK) {
    const response = {
      list: getTransactionList(params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}

// Get detailed information for the transaction
export function apiV2GetTransactionDetails(params: TDetailsParams): Promise<TListItem> {
  const url = '/f2c/v1/console/transaction/' + params.id;
  if (process.env.MOCK) {
    const response = getTransactionDetails();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return get(url, params);
}

// Send a callback for transaction
export function apiV2SendTransactionCallback(transaction_id: string): Promise<TListItem> {
  const url = '/f2c/v1/console/transaction/' + transaction_id + '/notify';
  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    return CancelablePromise.delay(500, response);
  }
  return post(url);
}
